import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-gray-900">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: January 2025</p>

        <div className="space-y-8 text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">1. Introduction</h2>
            <p className="mb-4">
              TESTBOOK LTD ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our driving test booking service.
            </p>
            <p>
              Company Number: 16836503<br />
              Registered Office: 20 Wenlock Road, London, England, N1 7GU
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">2. Information We Collect</h2>
            <p className="mb-4">We collect information that you provide directly to us, including:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Personal identification information (name, email address, phone number)</li>
              <li>Driving license number and details</li>
              <li>Test booking preferences and requirements</li>
              <li>Payment information (processed securely through third-party payment processors)</li>
              <li>Communication records with our customer service team</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">3. How We Use Your Information</h2>
            <p className="mb-4">We use the information we collect to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Process your driving test booking requests</li>
              <li>Communicate with you about your bookings and inquiries</li>
              <li>Send you booking confirmations and reminders</li>
              <li>Improve our services and customer experience</li>
              <li>Comply with legal obligations</li>
              <li>Prevent fraud and ensure security</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">4. Data Sharing and Disclosure</h2>
            <p className="mb-4">
              We do not sell, trade, or rent your personal information to third parties. We may share your information with:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Official UK driving test authorities (DVSA) for booking purposes</li>
              <li>Payment processors to complete transactions</li>
              <li>Service providers who assist in operating our website</li>
              <li>Law enforcement or regulatory bodies when legally required</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">6. Your Rights</h2>
            <p className="mb-4">Under UK GDPR, you have the right to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
              <li>Withdraw consent at any time</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">7. Data Retention</h2>
            <p>
              We retain your personal information for as long as necessary to provide our services and comply with legal obligations. Booking records are typically retained for 7 years in accordance with UK regulations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">8. Cookies and Tracking Technologies</h2>
            <p className="mb-4">
              Our website uses cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and understand user behavior.
            </p>
            <div className="mb-4">
              <h3 className="text-lg font-semibold mb-2 text-gray-800">Types of Cookies We Use:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Essential Cookies:</strong> Required for the website to function properly (e.g., session management, security)</li>
                <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website (e.g., Google Analytics)</li>
                <li><strong>Functional Cookies:</strong> Remember your preferences and settings</li>
                <li><strong>Marketing Cookies:</strong> Used to track visitors across websites for advertising purposes</li>
              </ul>
            </div>
            <p className="mb-4">
              <strong>Managing Cookies:</strong> You can control and manage cookies through your browser settings. You can choose to:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Accept all cookies</li>
              <li>Reject all non-essential cookies</li>
              <li>Delete cookies after your browsing session</li>
              <li>Block third-party cookies</li>
            </ul>
            <p className="text-sm text-gray-600">
              Please note that blocking or deleting cookies may affect your experience on our website and limit certain functionalities.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4 text-gray-900">9. Contact Us</h2>
            <p className="mb-4">
              If you have any questions about this Privacy Policy or wish to exercise your rights, please contact us:
            </p>
            <p>
              TESTBOOK LTD<br />
              20 Wenlock Road, London, England, N1 7GU<br />
              Email: info@testbook.co.uk<br />
              Company Number: 16836503
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;